import mitt from 'mitt'

const bus = new mitt()

export default bus
